import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

const About_blc = (props) => {
    const sectionTitle = props.val.blc_about_tag.split(" ");

    return (
        <section id="about">
            <Container>
                <div className="justify-content-center">
                    {/* <h2 className="text-center titles"> {props.val.blc_about_tag} </h2> */}
                    {/* <div className="section-title-container">
                        <h2 className="titles">
                            <span> {sectionTitle[0]}</span>
                            <span className='titles-black' > {sectionTitle[1]}</span>
                        </h2>

                        <hr style={{ width: '85%' }} />
                    </div> */}
                    <h2 className="sectionHeading titles">
                        <span className='titles-black me-2'>{sectionTitle[0]}</span>
                        <span>{sectionTitle[1]}</span>
                    </h2>
                    {/* <Row>
                        <Col xs={2}>
                            <h2 className="titles">
                                <span> {sectionTitle[0]}</span>
                                <span className='titles-black' > {sectionTitle[1]}</span>
                            </h2>
                        </Col>
                        <Col xs={10} className=''>
                            <hr className='title-hr' />
                        </Col>
                    </Row> */}
                    {/* <div className="myDiv"> </div> */}
                    <div className="about-padding">
                        <Row>
                            {/* <Col className="d-flex justify-content-center"> */}
                            <Col className="center-align-img">
                                <Image src={props.val.aboutUs_Img.data[0].attributes.formats.large.url} className="responsive" />
                            </Col>
                            <Col lg={6} className='caption-padding'>
                                <Container>
                                    <p>
                                        {props.val.blc_aboutus_text}
                                    </p>
                                    <p className=" quotes ">
                                        {props.val.about_usTextTwo}
                                    </p>
                                    <p style={{ WordSpacing: '1px' }}> {props.val.about_usTextThree}
                                    </p>
                                </Container>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </section>

    );
}

export default About_blc